import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import BiButton from '../biLogger/Components/BiButton';
import BiLink from '../biLogger/Components/BiLink';
import { withMobileContext } from '../Context';
import s from './Button.scss';
var defaultProps = {
    view: 'b1-1',
    type: 'button',
};
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var href = this.props.href;
        return href ? this.renderLinkButton() : this.renderRealButton();
    };
    Button.prototype.renderRealButton = function () {
        var _a = this.props, id = _a.id, name = _a.name, type = _a.type, disabled = _a.disabled, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, value = _a.value, children = _a.children, dataHook = _a.dataHook, dataRole = _a["data-role"], ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaHidden = _a["aria-hidden"], biData = _a.biData;
        return (React.createElement(BiButton, { id: id, name: name, type: type, disabled: disabled, className: this.getClassNames(), style: this.getInlineStyles(), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-hidden": ariaHidden, "data-role": dataRole, "data-hook": dataHook, value: value, biData: biData }, children));
    };
    Button.prototype.renderLinkButton = function () {
        var _a = this.props, href = _a.href, id = _a.id, type = _a.type, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, children = _a.children, dataRole = _a["data-role"], ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaHidden = _a["aria-hidden"], target = _a.target, biData = _a.biData, dataHook = _a.dataHook;
        return (React.createElement(BiLink, { id: id, href: href, type: type, className: this.getClassNames(), style: this.getInlineStyles(), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-hidden": ariaHidden, "data-role": dataRole, "data-hook": dataHook, target: target, biData: biData }, children));
    };
    Button.prototype.getClassNames = function () {
        var _a = this.props, disabled = _a.disabled, view = _a.view, withPaddings = _a.withPaddings, height = _a.height, className = _a.className, forceHoverStateWhenDisabledBecauseReasons = _a.forceHoverStateWhenDisabledBecauseReasons;
        return classnames(s['button'], view && s[view], this.isFullWidth() && s['full-width'], disabled && s['disabled'], withPaddings && s['with-paddings'], height && s["height-" + height], forceHoverStateWhenDisabledBecauseReasons &&
            disabled &&
            s['force-hover-state'], className);
    };
    Button.prototype.getInlineStyles = function () {
        var minWidth = this.props.minWidth;
        var styles = {};
        if (minWidth) {
            styles.minWidth = minWidth;
        }
        return styles;
    };
    Button.prototype.isFullWidth = function () {
        var _a = this.props, fullWidth = _a.fullWidth, isMobile = _a.isMobile, minWidth = _a.minWidth;
        return fullWidth !== undefined ? fullWidth : isMobile && !minWidth;
    };
    Button.defaultProps = defaultProps;
    return Button;
}(React.Component));
export default withMobileContext(Button);
//# sourceMappingURL=Button.js.map